import { render, staticRenderFns } from "./IconDocumentReportOutline.vue?vue&type=template&id=f6f79cf6"
import script from "./IconDocumentReportOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentReportOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports